define('StellarGrade.ST_Product.ProductViews.Price.View', ['item_productviewsprice.tpl', 'ProductViews.Price.View', 'underscore'], function (
    product_views_price_tpl,
    ProductViewsPriceView,
    _
) {
    'use strict';

    return {
        loadModule: function (container) {
            _.extend(ProductViewsPriceView.prototype, {
                template: product_views_price_tpl,

                getContext: _.wrap(ProductViewsPriceView.prototype.getContext, function (fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    return context;
                }),
            });
        },
    };
});
